import { render, staticRenderFns } from "./WechatCertificate.vue?vue&type=template&id=deb1d30e&"
import script from "./WechatCertificate.vue?vue&type=script&lang=js&"
export * from "./WechatCertificate.vue?vue&type=script&lang=js&"
import style0 from "./WechatCertificate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports